export default function FormField({
  label,
  htmlFor,
  error,
  helpText,
  children,
}) {
  return (
    <div className="mb-3">
      <label htmlFor={htmlFor} className="form-label fw-semibold">
        {label}
      </label>

      {children}

      {error && <div className="text-danger small mt-1">{error}</div>}

      {!error && helpText && (
        <div className="text-muted small mt-1">{helpText}</div>
      )}
    </div>
  );
}